<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2"><a id="page_v"></a>For my niece, Alexandra Rachel Carroll</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Dedication.vue?10ae6124